import axios from "axios";

const hyu = process.env.VUE_APP_HYU;
// const modelsHeader = {
//     'Content-Type': 'application/json',
//     'AccessToken': process.env.VUE_APP_MODELSTOKEN,
// }

const state = () => ({
  modelsPanoram: [],
  pending: false,
});

const getters = {
  getPanoramaicImgByVersion: (state) => (id, v) => {
    let res = state.modelsPanoram.find((el) => el.modelID == id);
    if (res) return res.colors.filter((el) => el.version == v);
    return false;
  },
  modelHasPanoramImgs: (state) => (id) => {
    let bool = state.modelsPanoram.find((el) => el.modelID == id);
    return bool ? true : false;
  },
  isPanrmPending: (state) => state.pending
};

const mutations = {
  UPDATE_PANORAMIC_STATE(state, payload) {
    state = Object.assign(state, payload);
  },
};

const actions = {
  fetchPanoramImg({ commit, getters }, id) {
    if (getters.modelHasPanoramImgs(id)) return;

    commit("UPDATE_PANORAMIC_STATE", {
      pending: true,
    });

    let url = hyu + process.env.VUE_APP_API_PANORAM + id;
    // axios.get(url, { headers: modelsHeader })
    axios
      .get(url)
      .then((res) =>
        commit("UPDATE_PANORAMIC_STATE", {
          modelsPanoram: res.data,
          pending: false,
        })
      )
      .catch((err) => console.log(err));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
